export enum ProxyRuleProtocol {
    Http = 'http',
    Smtp = 'smtp',
}
